export default {
  pageTitle: "Commande d'adhésion",
  progressSteps: {
    version: "Version:",
    versionInfoText:
    " Health Info Net SA - ",
  },
  supportLink: "https://support.hin.ch/fr/",
  support: "Support HIN",
  supportPanel: {
    customerService: {
      header: "Centre clients HIN",
      contactForm: "Formulaire de contact",
      contactFormUrl: "https://www.hin.ch/fr/contact/formulaire/",
      phoneSwiss: " 0848 830 741",
      phoneInternational: " +41 52 235 02 75",
      international: " (International)",
      openingHoursTitle: "Horaires d’ouverture: ",
      openingHours: "Lundi au vendredi 08h00 à 18h00",
      openingHoursNoon: "",
      openingHoursAfternoon: "",
    },
  },
  appErrors: {
    backendCommunicationError:
      "Un problème de connexion est survenu avec le serveur." +
      " Veuillez réessayer plus tard." +
      " Si le problème persiste, veuillez contacter le {supportLink}.",
      failedBackendCall:
      "Validation impossible, veuillez vérifier votre connexion Internet.",
  },
  appComponents: {
    inputTeamName: "Nom d’affichage",
    btnBack: "Retour",
    smallText:
      "Ce nom est affiché comme expéditeur de l’e-mail, p. ex. cabinet Modèle",
    inputFirstName: "Prénom",
    inputLastName: "Nom",
    inputEmail: "Adresse e-mail (privée)",
  },
  membersForm: {
    contractAdjustment: "Commander des identités HIN supplémentaires pour un contrat existant",
    contractAdjustmentText:
      "Avez-vous, ou votre organisation, déjà un contrat ? Dans ce cas, veuillez utiliser " +
      "le formulaire {mutationForm} pour demander la modification souhaitée.",
    hereLinkText: "ici",
    intro:
        "En tant que membre HIN, vous recevez une identité HIN, c'est-à-dire une identité " +
        "électronique (eID), qui vous permet d'échanger des informations avec d'autres membres HIN, " +
        "par exemple par e-mail, dans le respect de la protection des données. " +
        "Pour plus d'informations, consultez notre {overviewLink}.",
    mutationForm: "modification souhaitée",
    mutationFormUrl: "https://home.hin.ch/fr/modification-du-contrat/",
    memPricingLink: "https://www.hin.ch/fr/adhesion/adhesion-a-hin.cfm",
    memFooterTitle: "Faites-vous partie d'une association ?",
    memAssociation: {
      header: "Offres spéciales",
      overviewLink: "Aperçu Adhésion",
      specialCondition:
        "En tant que membre de l'association, vous bénéficiez de conditions spéciales " +
        "et d'une extension personnalisée pour votre adresse e-mail " +
        "{'(exemple : @berufsverband-hin.ch)'}. L'offre est valable pour toute commande " +
        "comprenant au moins une eID personnelle et une eID d'équipe. " +
        "En savoir plus {overviewLink}.",
    },
    modalTitle: "Veuillez noter",
    modalMemberTitle: "Adhésion à HIN {association}",
    // removed {association} variable here due to text changes
    // code for using the variable is still available in case it is needed
    modalText:
      "Des conditions spéciales s’appliquent à cette offre. " +
      "Veuillez la commander via le lien suivant: ",
    modalTextUrl: "Commander une offre",
    modalDismissButton: "OK",
  },
  identityForm: {
    gwInfoHeader: "Ajoutez une ou plusieurs eIDs.",
    gwInfoText: "Si vous souhaitez commander un plus grand nombre d’eIDs (10, 15 ou plus), une affiliation {gwUrlText} pourrait être intéressante pour vous.",
    gwInfoUrl: "https://www.hin.ch/fr/adhesion/adhesion-collective/avec-gateway.cfm",
    gwUrlText: "collective avec Gateway",
    popoverTitle: "Attention:",
    popoverNoIds: "Veuillez sélectionner au moins une eID",
    popoverMessage:
      "Pour bénéficier des {popoverAssocContractUrlText}," +
      " vous devez ajouter au moins une identité personnelle et une identité d'équipe. " +
      "Avec l'avantage association, vous recevrez une adresse e-mail avec le domaine de l'association (par ex. {'@'}physio-hin.ch).",
    popoverMessageFmh: "Pour bénéficier des conditions spéciales réservées aux membres FMH, vous devez ajouter au moins deux identités.",
    popoverAssocContractUrlText: "conditions spéciales réservées aux membres des associations partenaires",
    popoverAssocContractUrl: "https://www.hin.ch/fr/adhesion/adhesion-collective/associations.cfm",
    personalCard: {
      persCardHeader: "Mon eID personnelle",
      compareToId:
        "Est comparable à un document d’identité, mais dans un contexte numérique",
      uniquePerson:
        "Une seule personne est autorisée à utiliser l’eID personnelle.",
      appAccess:
        "Accès aux applications contenant des données sensibles (p. ex. DEP)",
      hinServices:
        "Utilisation des services HIN tels que HIN Mail, HIN Sign",
      eRecipeService: "Utilisation du service E-Ordonnance Suisse par les médecins et les pharmacies",
      emailExample: "L’adresse e-mail d’une eID personnelle peut par exemple ressembler à prénom.nom{'@'}hin.ch",
    },
    teamCard: {
      teamCardHeader: "eID d’équipe",
      multiplePersons: "Peut être partagée entre plusieurs personnes",
      limitedAccessData: "Accès impossible aux données sensibles (p. ex. DEP)",
      limitedAccessServices: "Accès limité aux services DEP",
      eRecipeServiceTeam: "Traitement des ordonnances électroniques du service E-Ordonnance Suisse par les pharmacies",
      emailExample: "L’adresse e-mail d’une eID d’équipe peut par exemple ressembler à cabinet.exemple{'@'}hin.ch."
    },
    addButtons: {
      teamLinkText: "Ajouter une eID d’équipe",
      persLinkText: "Ajouter une eID personnelle",
      mpaLinkText: "Ajouter une eID personnelle pour AM / CMA / personnel de pharmacie",
    },
    firstPersonalForm: "eID personnelle (preneur de contrat / détenteur de l’ID)",
    persFormName: "eID personnelle (détenteur de l’ID)",
    mpaFormString: "eID AM personnelle (détenteur de l’ID)",
    trashCanText: "Supprimer",
    whatIsEidPers: "Qu’est-ce qu’une eID personnelle?",
    whatIsEidTeam: "Qu’est-ce qu’une eID d’équipe?",
    whatIsEidLink: "https://support.hin.ch/fr/identite-hin/difference-identite-personnelle-identite-de-cabinet/",
    errors: {
      duplicateMailError: "Une même adresse e-mail ne peut pas être utilisée pour plusieurs eID. " +
        "L’adresse indiquée doit être personnelle, car nous l’utilisons pour générer le mot de passe.",
      hinMailExistingError: "L’adresse e-mail {currentHinEmail} est déjà attribuée à une eID HIN. " +
        "Veuillez prendre contact avec le {supportLink} afin de déterminer la marche à suivre.",
      singleTeamFormError: "Lors de la sélection de l’association partenaire « SVMED », une seule eID d’équipe peut être commandée."
    },
  },
  emailForm: {
    forward: "Suivant",
    persHeader: "eID personnelle",
    mpaHeader: "eID personnelle pour AM / CMA / personnel de pharmacie",
    teamHeader: "eID d’équipe",
    infoTextMail:
      "Ces adresses sont des suggestions. Les adresses e-mail définitives seront vérifiées et attribuées ultérieurement. ",
    infoTextPleaseConsider: "Veuillez tenir compte des points suivants lors de la sélection de l’adresse e-mail pour votre eID personnelle:",
    infoTextFullName: "L’adresse e-mail doit impérativement contenir votre nom de famille complet",
    infoTextFirstName: "Vous pouvez au choix abréger votre prénom ou l’indiquer en entier",
    infoTextFantasyName: "Les noms fantaisistes ne sont pas autorisés",
    praxisSoftwareLabel:
      "Combiner l’adhésion avec le logiciel de cabinet suivant",
    praxisSoftwareInfo:
      "La combinaison avec le logiciel de cabinet a une influence sur le domaine de l’e-mail.",
    praxisSoftwareSelect: "Choisir un logiciel de cabinet",
    noPraxisSoftware: "no-software",
    praxisSoftwareOptions: {
      "no-software": "Ne pas connecter de logiciel de cabinet",
      softplus: "Softplus",
      physiosys: "Physiosys",
      sophisware: "Sophisware",
    },
  },
  offerForm: {
    errorModal: {
      header: "Une erreur est survenue",
      text: "Nous n’avons malheureusement pas pu établir votre offre. Veuillez contacter le {supportLink}.",
      errorCode: "Code d’erreur",
    },
    offerMismatchModal: {
      header: "Attention",
      intro: "Le nombre minimal/maximal d’eID personnelles et/ou / le nombre minimal/maximal "
        +"d’eID d’équipe – ou éventuellement seulement d’eID pour cette offre d’association – n’est pas rempli. "
        +"Veuillez commander le nombre nécessaire, faute de quoi le rabais ne s’appliquera pas. "
        +"De plus, le cas échéant, vous ne recevrez pas d’adresse e-mail avec l’extension de l’association. "
        +"Vous trouverez les conditions sur www.hin.???",
      numTeamIds: "d’eID d’équipe HIN",
      numTotPersIds: "d’eID personnelles (y c. AM)",
      numTotIds: "d’eID personnelles et d’équipe",
      minimum: "Minimum",
      maximum: "Maximum",
    },
    pageHeaders: {
      single: "Adhésion individuelle",
      collective: "Adhésion collective",
      collectiveAssociation: "Adhésion collective association",
    },
    tableHeaders: {
      countText: "Nombre",
      singlePriceText: "Prix unitaire",
      totalPriceText: "Prix total",
    },
    tableContentAdmission: {
      admissionCostText: "Coûts uniques",
      admissionChargeText: "Coûts d’admission uniques",
      associationBenefitText: "Avantage de l’offre pour association",
      admissionCostTotalText: "Total coûts uniques",
      admissionFeeText: "Frais d’admission",
      admissionDiscountText: "Avantage de l’offre pour association Association { name }",
    },
    tableContentAnnual: {
      annualCostText: "Coûts annuels",
      personalIdsText: "Cotisation annuelle eID personnelle",
      personalIdsDiscount: "Rabais",
      mpaIdsText: "Cotisation annuelle eID personnelle AM",
      teamIdsText: "Cotisation annuelle eID d’équipe HIN",
      annualDiscountText: "Avantage de l’offre pour association Association { name }",
      annualCostTotalText: "Total coûts annuels",
    },
    sponsorText: "Sponsor:",
    totalAmountText: "Montant total",
    btnForward: "Accepter et continuer",
    followUp: "Suivi des informations contractuelles",
    retired: "Je suis à la retraite",
    currency: "CHF",
    mutationFeeText: "Frais de mutation",
  },
  contractDetail: {
    button: {
      forward: "Conclure le contrat",
      savingInProgressTitle: "Enregistrer..",
      savingInProgressText: "Veuillez patienter",
      eIdErrorsTitle: "Données erronées à l’étape 3",
      eIdErrorsText:
        "Les adresses e-mail indiquées ne correspondent pas aux exigences."
        + " Veuillez vérifier vos données à l’étape 3.",
      formErrorsTitle: "Données manquantes",
      formErrorsText: "Veuillez remplir tous les champs marqués d’un astérisque (*).",
      savingErrorsTitle: "Erreur lors de l’enregistrement",
      savingErrorsText:
        "Une erreur est survenue lors de l’enregistrement. Veuillez vérifier votre connexion Internet."
        + " Si le problème persiste, contactez le { supportLink }.",
      savingTitle: "Données OK",
      savingText: "Les données sont enregistrées. Vous allez être redirigé.",
    },
    noBelongToOrg: "Je n’appartiens à aucune organisation / institution",
    forOrganization: {
      title: "Organisation",
      titleBusinessContactPerson: "Personne de contact",
      orgName: "Nom de l’organisation",
      email: "Adresse e-mail de l’organisation (existante)",
      tel: "Téléphone de l’organisation",
      gln: "GLN de l’organisation",
      glnLookupPending: "Veuillez patienter, nous recherchons votre GLN dans RefData",
      businessContactPhone: "Téléphone portable",

      cbAckLegalOrgSingleMembership:
        "Par la présente, je confirme" +
        " que les conditions de base pour la conclusion du contrat sont remplies" +
        " et que les informations fournies sont exactes." +
        " En outre, j’ai lu et accepté les documents contractuels suivants: {cbAckLegalOrgSingleMembershipContract}",
      cbAckLegalOrgSingleMembershipContract: "Contrat-cadre Adhésion individuelle",
      cbAckLegalOrgSingleMembershipContractLink: "https://www.hin.ch/files/pdf1/contrat-cadre_adhesion_individuelle_a_hin.pdf",
      cbAckLegalOrgSinglePersonallyResponsible:
        "J’ai pris note" +
        " qu’en concluant ce contrat en tant que membre individuel HIN," +
        " je suis personnellement responsable de la protection des données – et" +
        " non l’organisation indiquée.",

      cbAckLegalOrgCollectiveMembership:
        "Par la présente, je confirme" +
        " que les conditions de base pour la conclusion du" +
        " contrat sont remplies et que les informations fournies sont" +
        " exactes." +
        " En outre, j’ai lu et accepté les documents contractuels suivants: {cbAckLegalOrgCollectiveMembershipContract}",
        cbAckLegalOrgCollectiveMembershipContract: "Contrat-cadre Adhésion collective",
        cbAckLegalOrgCollectiveMembershipContractLink: "https://www.hin.ch/files/pdf1/contrat-cadre_adhesion_collective_a_hin.pdf",
    },
    forPersonal: {
      cbAckLegalPersSingleMembership:
        "Par la présente, je confirme" +
        " que les conditions de base pour la conclusion du" +
        " contrat sont remplies et que les informations fournies sont" +
        " exactes." +
        " En outre, j’ai lu et accepté les documents contractuels suivants: {cbAckLegalPersSingleMembershipContract}",
        cbAckLegalPersSingleMembershipContract: "Contrat-cadre Adhésion individuelle",
        cbAckLegalPersSingleMembershipContractLink: "https://www.hin.ch/files/pdf1/hin_rahmenvertrag_einzelmitgliedschaft.pdf",
      cbAckLegalPersSinglePersonallyResponsible:
        "J’ai pris note" +
        " qu’en concluant ce contrat en tant que" +
        " membre individuel HIN, je suis personnellement responsable de la protection des données.",

      cbAckLegalPersCollectiveMembership:
        "Par la présente, je confirme" +
        " que les conditions de base pour la conclusion du" +
        " contrat sont remplies et que les informations fournies sont" +
        " exactes." +
        " En outre, j’ai lu et accepté les documents contractuels suivants: {cbAckLegalPersCollectiveMembershipContract}",
        cbAckLegalPersCollectiveMembershipContract: "Contrat-cadre Adhésion collective",
        cbAckLegalPersCollectiveMembershipContractLink: "https://www.hin.ch/files/pdf1/contrat-cadre_adhesion_collective_a_hin.pdf",
      cbAckLegalPersCollectivePersonallyResponsible:
        "J’ai pris note" +
        " que sans indication d’une organisation" +
        " (personne morale), je suis personnellement responsable" +
        " de la protection des données pour le contrat conclu.",
    },
    inputs: {
      emailCorrespondence: "Adresse e-mail pour la correspondance (privée)",
      orderCovercardService: "Je souhaite activer le {covercardService}",
      covercardService: "Service Covercard",
      covercardServiceLink: "https://www.hin.ch/fr/services/hin-service-covercard/service-covercard-hin.cfm",
      covercardTitle: "Covercard",
      covercardItemPrice: "{ amount } CHF",
      cardReaderInfoText: "Découvrez {cardReaderHere}, la liste des lecteurs de cartes pris en charge par votre logiciel de cabinet.",
      cardReaderlink: "https://www.hin.ch/files/pdf1/logiciels-pour-cabinets-medicaux-covercard.pdf",
      cardReaderHere: "ici"
    },
    addressAdditional: "Complément d’adresse",
    organizationType: "Type d’organisation",
  },
  furtherInformation: {
    glnInfoUrl: "https://www.refdata.ch/fr/partenaires/requete/base-de-donnees-des-partenaires-gln",
    glnInfoUrlFr: "",
    button: {
      back: {
        warningTitle: "Retour au contrat impossible",
        warningText:
          "Les données relatives au contrat ne peuvent plus être modifiées. Veuillez terminer le processus de commande " +
          "(y c. l’identification vidéo) et signalez-nous tout changement par téléphone au {backPhoneNumber} " +
          "ou via {backContactForm}.",
        backPhoneNumber: "0848 830 740",
        backContactForm: "Formulaire de contact",
      },
      formErrorsTitle: "Données manquantes",
      formErrorsText: "Veuillez remplir tous les champs marqués d’un astérisque (*).",
      savingErrorsTitle: "Erreur lors de l’enregistrement",
      savingErrorsText:
        "Une erreur est survenue lors de l’enregistrement. Veuillez vérifier votre connexion Internet."
        + " Si le problème persiste, contactez le { supportLink }. ",
      savingInProgressTitle: "Enregistrer..",
      savingInProgressText: "Veuillez patienter",
      savingTitle: "Données OK",
      savingText: "Les données sont enregistrées. Vous allez être redirigé.",
    },
    glnLookupPending:
      "..Veuillez patienter un instant, nous recherchons votre GLN dans les registres",
    person: {
      // removed (Maximum: 3) from the key so the text fits in the button
      addJobName: "Ajouter une autre profession de santé",
      title: "Données personnelles",
      header: "eID personnelle pour",
      gln: "GLN personnel",
      accessGln: "Pour accéder au DEP, il faut impérativement indiquer un GLN.",
      mpaEpdGlnHint:
        "Pour accéder au DEP, il est obligatoire de fournir un GLN." +
        " Vous pouvez terminer le processus de commande sans indiquer de GLN." +
        " Si vous avez besoin de l’accès au DEP à une date ultérieure," +
        " le GLN peut être indiqué ultérieurement.",
      ackLegal:
        "Par la présente, je confirme que les informations fournies sont exactes et j'accepte la {privacyPolicy} de HIN ainsi que les informations relatives à l’{onlineRegistration}.",
      onlineRegistration: "utilisation de l’inscription en ligne",
      onlineRegistrationLink: "https://www.hin.ch/fr/information/inscription-en-ligne.cfm",
      privacyPolicy: "déclaration de protection des données",
      privacyPolicyLink: "https://www.hin.ch/fr/declaration-de-protection-des-donnees-de-health-info-net-ag-hin/",
      button: {
        forward: "Suivant",
      },
    },
    infoTextFindGln: "Rechercher GLN",
    infoTextFindGlnFr: "",
    cardReaderOrder: "Lecteur payant",
    practiceSoftware: "Quel logiciel de cabinet utilisez-vous?",
    tokenExpiredTitle: "Date limite d’inscription dépassée",
    tokenExpiredText:
      "Votre fenêtre de connexion a expiré. Veuillez contacter le {supportLink}.",
    videoIdentAlreadyCompleted:
      "La commande a été enregistrée avec succès ; elle sera traitée sous peu" +
        " par HIN et vous recevrez ensuite un e-mail vous indiquant la marche à suivre."
  },
  videoIdentification: {
    title: "Identification vidéo",
    introTextDev: "La commande a été enregistrée avec succès ; elle sera traitée sous peu" +
      " par HIN et vous recevrez ensuite un e-mail vous indiquant la marche à suivre.",
  },
  additionalInvitations: {
    withEids: {
      title:
        "Invitation pour identité personnelle | Invitations pour identités personnelles",
      intro:
        "Vous avez commandé une identité HIN personnelle (eID HIN) pour une autre personne." +
        " Cette personne vient de recevoir un e-mail l’invitant à s’enregistrer." +
        " | Vous avez commandé des identités HIN personnelles pour d’autres personnes." +
        " Ces personnes viennent de recevoir un e-mail les invitant à s’enregistrer.",
      tableExplanation:
        "Invitations à: | Invitations à:",
      infoByEmail:
      "Après le traitement de votre eID, les données d’accès vous seront envoyées par e-mail."
        // "Vous recevrez des informations sur la procédure à suivre" +
        // " après l’envoi de l’invitation par e-mail à { email }." +
        // " | Vous recevrez des informations sur la procédure à suivre" +
        // " après l’envoi des invitations par e-mail à { email }.",
    },
    withoutEids: {
      title: "Merci pour votre commande",
      text:
        "La commande a été enregistrée avec succès ; elle sera traitée sous peu" +
        " par HIN et vous recevrez ensuite un e-mail vous indiquant la marche à suivre."
    },
    error: {
      title: "Une erreur est survenue lors de la transmission des données.",
      restart: "Veuillez relancer l’identification vidéo:",
      text:
        "Vous pouvez également procéder à l’identification ultérieurement." +
        " Nous vous avons envoyé le lien correspondant à {email}." +
        " ",
      restartIdent: "Ici",
      noMatch:
        "Vos données n’ont pas été trouvées. Veuillez vous adresser" +
        " au {supportLink}.",
      noMatchButShowSuccess:
        "La commande a été enregistrée avec succès ; elle sera traitée sous peu" +
        " par HIN et vous recevrez ensuite un e-mail vous indiquant la marche à suivre."
    },
    loading: {
      title: "Veuillez patienter",
      text: "Veuillez patienter un instant. Vous allez être redirigé/e.",
    },
    table: {
      description:
        "Tableau listant les eID qui reçoivent un e-mail d’invitation",
      header: {
        name: "Détenteur de l’ID",
        email: "Adresse e-mail",
        subject: "Objet de l’e-mail",
      },
      body: {
        subject: "Enregistrement de votre identité HIN",
      },
    },
    button: {
      invitationMailsSending:
        "L'e-mail est envoyé" +
        " | Les e-mails sont envoyés",
      sendInvitationMails:
        "Envoyer un e-mail" +
        " | Envoyer des e-mails",
      invitationMailsSent:
        "Les invitations ont été envoyées." +
        " | Les invitations ont été envoyées.",
      invitationMailsFailure:
        "Erreur lors de l’envoi. Veuillez contacter le {supportLink}.",
      close: "Vous pouvez maintenant fermer la fenêtre",
    },
  },
  // Generic keys for forms
  form: {
    button: {
      forward: "Suivant",
    },
    association: "Association professionnelle",
    associationMemberNumber: "Numéro de membre Association professionnelle",
    birthdate: "Date de naissance",
    correspondenceLanguage: "Langue de correspondance",
    errorMessage: "Les champs marqués en rouge sont vides ou contiennent des informations erronées.",
    street: "Rue",
    streetNo: "N°",
    city: "Lieu",
    zipCode: "NPA",
    selectionPlease: "(Veuillez sélectionner)",
    country: "Pays",
    glnErrors: {
      onlyDigits: "Le GLN ne doit contenir que des chiffres.",
      noMatch: "Le GLN saisi n’a pas été trouvé dans le registre.",
      noMatchPerson:
        "Aucune entrée trouvée. Indiquez un GLN valide ou laissez le champ vide.",
      tooShort: "Le GLN indiqué est trop court.",
      tooLong: "Le GLN indiqué est trop long.",
      unknownError:
        "Le GLN indiqué n’a pas pu être trouvé.",
    },
    glnText:
      "Le Global Location Number (GLN) sert à une identification univoque" +
      " les personnes physiques et morales (p. ex. professionnel de la santé, organisation de santé)" +
      " et les lieux physiques (p. ex. bâtiment, entrepôt). {0}",
    glnTitle: "GLN",
    glnUrlText: "Informations complémentaires",
    profession: "Profession / Profession de santé",
    profTitle: "Titre de spécialiste",
    salutation: "Civilité",
    salTitle: "Titre académique",
    mailto: "Adresse e-mail (privée)",
    mobilePhone: "Téléphone portable",
    name: "Nom",
    firstName: "Prénom",
    lastName: "Nom",
    billingAddress: "Adresse de facturation",
    differentInvoiceAddress: "Adresse de facturation différente",
    feedbackMessageTitle: "Remarque",
    feedbackMessageLabel: "Vous souhaitez nous faire part de quelque chose?",
    contractTerms: "Dispositions contractuelles",
    errors: {
      "Failed string anyNv missing parameter value":
        "Veuillez faire votre choix.",
      "Missing property": "Veuillez remplir",
      codeLabel: "Code d’erreur: ",
      specialCharacters: "n’utilisez pas de caractères spéciaux ou de chiffres",
      missingProperty: "Veuillez saisir {label}",
      unknownMailServer: "Le domaine de messagerie (p. ex. {'@'}hin.ch) ne peut pas être modifié.",
      invalidEmail: "Veuillez saisir une adresse e-mail valide.",
      checkRegulations: "Veuillez accepter les termes du contrat",
      invalidTelNrSwitzerland: "Veuillez saisir un numéro de téléphone à 9 chiffres",
      invalidTelNrLiechtenstein: "Veuillez saisir un numéro de téléphone à 7 chiffres",
      invalidTelNrOther: "Veuillez saisir un numéro de téléphone à 7-13 chiffres",
    },
  },
  Fernwartung:
    "TODO: make key English, Fill in Text. I have just put the key here to silence a warning",
  countries: {
    CH: "Suisse",
  },
  register: {
    infoFoundInRegister: "Entrée trouvée dans {register}",
  },
  sidebar: {
    steps: {
      membership: "Bienvenue - Devenir membre de HIN",
      identities: "Identités (eID)",
      identitiesAndMail: "Identités (eID) et adresses e-mail",
      hinEmails: "Adresses e-mail",
      hinEmailSelect: "Sélectionner les adresses e-mail",
      offer: "Offre",
      contractDetail: "Données contractuelles",
      furtherInfo: "Données personnelles",
      videoIdentification: "Identification vidéo",
    },
  },
};
